import React from 'react'
import banner from '../../assets/images/yotube banner.png'
import MeImg from '../../assets/images/Me.png'
import SkillsImg from '../../assets/images/Skills.png'

export const About = () => {
  return (
    <div className="about-page">
      <section className="about-banner">
        <div className="container">
          <div className="bunner">
            
            <img src={banner} className="bunner-img" alt="YouTube banner" />
          </div>
        </div>
      </section>

      <section className="about-intro">
        <div className="container">
          <div className="about-intro__wrapper">
            <div className="about-intro__img">
              <img src={MeImg} width="258" height="260" alt="Bunyod Ag'zamxo'jayev" />
            </div>
            <div className="about-intro__content">
              <p className="about-intro__label">About Me</p>
              <h1 className="about-intro__title">
                Hi, I'm <span className="text-color">Bunyod Ag'zamxo'jayev</span>
              </h1>
              <p className="about-intro__text">
                I'm a Frontend developer who studied at NajotTalim and has been working in the field for 6+ years.
                I create user-friendly and modern websites that balance user needs with business goals.
              </p>
              <p className="about-intro__text">
                I believe that if the design does not impress you, nothing else will. That's why I focus on
                building visually appealing, responsive, and accessible interfaces that deliver real value.
              </p>
              <p className="about-intro__text">
                Currently, I work with a large team and appreciate improving people's lives through convenient,
                well-crafted digital products.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-skills">
        <div className="container">
          <h2 className="about-skills__title">
            My <span className="text-color">Skills</span>
          </h2>
          <p className="about-skills__subtitle">
            Technologies and tools I use to bring ideas to life on the web.
          </p>
          <div className="about-skills__img">
            <img src={SkillsImg} alt="Skills overview" />
          </div>
        </div>
      </section>

      <section className="about-contact">
        <div className="container">
          <h2 className="about-contact__title">Let's work together</h2>
          <p className="about-contact__text">
            I'm currently building mutually beneficial sites that value improving people's lives.
            Feel free to reach out through social media links in the footer.
          </p>
        </div>
      </section>
    </div>
  )
}
